import { useContext } from "react";
import { UUID } from "crypto";
import { NawyPassportContext } from "@/modules/common/context/nawy-passport.provider";
import { userHasPermission } from "@/modules/common/utils";
import { PermissionLevel, PermissionsEnum } from "@/modules/common/types";
import PermissionGuard from "@/modules/common/components/wrappers/permission-guard";
import ResponsiveModal from "@/modules/common/components/ui-kit/modals/responsive-modal";
import EditAdset from "@/modules/lead-page/components/lead-info/edit-fields/adset";
import LeadInfoField from "@/modules/lead-page/new/components/lead-info-field";
import useLeadInfo from "@/modules/lead-page/hooks/lead-info/lead-info.hook";
import FieldWrapper from "@/modules/lead-page/new/components/sidebar/fields/field-wrapper";

const AdsetField = () => {
  const { adset, isLoading, handleConfirmUpdate } = useLeadInfo();
  const { permissions: currentUserPermissions } =
    useContext(NawyPassportContext);

  return (
    <LeadInfoField
      editable={userHasPermission(
        {
          name: PermissionsEnum.EDIT_JOURNEY_CAMPAIGN_DETAILS,
          level: PermissionLevel.WRITE,
        },
        currentUserPermissions
      )}
      sxInnerBox={{
        justifyContent: "space-between",
      }}
      content={adset.value || "Not Set"}
      setEditModalOpen={adset.setEditAdsetModalOpen}
      editModalOpen={adset.editAdsetModalOpen}
      editModal={
        <PermissionGuard
          permissions={[
            {
              name: PermissionsEnum.EDIT_JOURNEY_CAMPAIGN_DETAILS,
              level: PermissionLevel.WRITE,
            },
          ]}
        >
          <ResponsiveModal
            open={adset.editAdsetModalOpen}
            onClose={() => {
              adset.setEditAdsetModalOpen(false);
              adset.setState(null);
            }}
            title="Edit Adset"
            confirmButtonText="Save"
            cancelButtonText="Cancel"
            onConfirm={() => {
              handleConfirmUpdate({
                lead: {
                  adsetUId: adset.state?.uid as UUID,
                },
              });
              adset.setState(null);
            }}
            isLoading={isLoading}
            isConfirmDisabled={!adset.state}
            snapPoints={[1]}
          >
            <FieldWrapper>
              <EditAdset adset={adset} />
            </FieldWrapper>
          </ResponsiveModal>
        </PermissionGuard>
      }
    />
  );
};

export default AdsetField;
